import { render, staticRenderFns } from "./CardPromotion.vue?vue&type=template&id=28918f7f&"
import script from "./CardPromotion.vue?vue&type=script&lang=js&"
export * from "./CardPromotion.vue?vue&type=script&lang=js&"
import style0 from "./CardPromotion.vue?vue&type=style&index=0&id=28918f7f&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports